import type { Element } from "./board";

export const ELEMENTS: readonly Element[] = ["fire", "ice", "lightning"];
// Keep very long runs finite even after the painted forms reach their largest band.
export const powerForTier = (tier: number): number => 2 ** Math.min(tier - 1, 50);
export const hpForTier = (tier: number): number => 64 * powerForTier(tier);
export const damageForTier = (tier: number): number => 18 * powerForTier(tier);

// Fire melts Ice, Ice grounds Lightning, and Lightning scatters Fire.
export function elementMultiplier(attacker: Element, defender: Element): number {
  if (attacker === defender) return 0.5;
  return (attacker === "fire" && defender === "ice") ||
    (attacker === "ice" && defender === "lightning") ||
    (attacker === "lightning" && defender === "fire") ? 1.4 : 0.8;
}

export class Rng {
  constructor(public state: number) { this.state >>>= 0; }
  next(): number {
    this.state = (Math.imul(this.state, 1664525) + 1013904223) >>> 0;
    return this.state / 4294967296;
  }
}

export function hashSeed(text: string, seed: number): number {
  let result = seed >>> 0;
  for (const char of text) result = Math.imul(result ^ char.charCodeAt(0), 16777619) >>> 0;
  return result;
}
